import { ColumnProps } from './interface';

export default {
  name: 'ATableColumn',
  props: ColumnProps
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/table/Column.js
// module id = 870
// module chunks = 0